import React from 'react'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { GridDragIcon } from '@mui/x-data-grid'
import {
  ClassroomTaskResponse,
  useClassroomAddIspeakTaskToClassroomTasksMutation,
} from '@app/services/auto-generated/classroom'
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  Typography,
} from '@common/components'
import { AddCircleOutlineOutlinedIcon } from '@common/icons'

interface MenuNoteProps {
  task: ClassroomTaskResponse
  listeners?: any
  attributes?: any
  isDragging?: boolean
}
const MenuIspeakNote: React.FC<MenuNoteProps> = (props) => {
  const { task } = props
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClosePopover = () => {
    setAnchorEl(null)
  }

  const [addIspeakTaskToClassroomTasks] = useClassroomAddIspeakTaskToClassroomTasksMutation()

  const handleAddTask = async () => {
    await addIspeakTaskToClassroomTasks({
      addIspeakTaskToClassroomTasksRequest: { task_id: task?.id },
    }).unwrap()
    handleClosePopover()
  }

  return (
    <>
      <IconButton
        sx={{ position: 'absolute', top: 0, right: 0, zIndex: 10 }}
        color='dark'
        onClick={handleClick}
      >
        <MoreHorizIcon />
      </IconButton>
      <IconButton
        color='dark'
        sx={{
          cursor: props.isDragging ? 'grabbing' : 'grab',
          '&:hover, &:active': {
            backgroundColor: 'transparent',
          },
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 10,
        }}
        {...props.listeners}
        {...props.attributes}
      >
        <GridDragIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: { borderRadius: '4px' },
        }}
      >
        <MenuList>
          <MenuItem onClick={handleAddTask}>
            <ListItemIcon>
              <AddCircleOutlineOutlinedIcon color='info' fontSize='small' />
            </ListItemIcon>
            <ListItemText>
              <Typography color='info'>Add to my tasks</Typography>
            </ListItemText>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  )
}

export default MenuIspeakNote
